/**
 * Таймаут REST-запроса клиента к демону, мс.
 *
 * Запрос к демону ждёт до 35 с, потому что при выкатке фронт перезапускается
 * за 12–16 с (замер 19–20.10.2026), а прокси держит запрос до его подъёма
 * (`lb_try_duration` в deploy/Caddyfile, DEN-136). Если таймаут короче,
 * браузер обрывает запрос, который прокси отдал бы новому фронту. 35 с —
 * двойной запас к наблюдённому окну.
 *
 * Значение одно на все запросы: прежние 10 с у лёгких и 15 с у тяжёлых
 * (детали плотности, библиотека) оба короче окна выкатки. Верхняя граница
 * всё равно нужна: демон, принявший соединение и не ответивший, иначе
 * оставляет экран в «загружается» навсегда, а `logout` не завершается
 * (design review stage5-auth-sessions, пункт 2; настройки аккаунта — Д4).
 *
 * Короче `lb_try_duration` (60 с) намеренно: срок прокси с запасом покрывает
 * холодный старт для проверки выкатки, а клиенту 35 с вдвое покрывают
 * наблюдённое окно. Запрос в начале холодного старта дольше 35 с вернёт
 * «недоступно» — меньшее зло, чем экран, висящий минуту при зависшем демоне.
 * Выход (`logout`) и «Проверяем сессию…» при зависшем демоне теперь ждут до
 * 35 с вместо 10 (DEN-136).
 */
export const DAEMON_REQUEST_TIMEOUT_MS = 35_000;
